import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import edgeOfferingsState from './state';
export const edgeOfferingsSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => edgeOfferingsState);
    },
    initialState: edgeOfferingsState,
    name: 'edgeOfferings',
    reducers: {
        errorReceiveCreateEdgeOffering: state => {
            state.requestingCreateEdgeOffering = false;
        },
        errorReceiveEdgeOffering: state => {
            state.edgeOffering = undefined;
            state.requestingEdgeOffering = false;
        },
        errorReceiveEdgeOfferings: state => {
            state.edgeOfferings = undefined;
            state.requestingEdgeOfferings = false;
        },
        errorReceiveModifyEdgeOffering: state => {
            state.requestingModifyEdgeOffering = false;
        },
        errorReceiveRemoveEdgeOffering: state => {
            state.requestingRemoveEdgeOffering = false;
        },
        errorReceiveTargetProfileEdgeOfferings: state => {
            state.requestingTargetProfileEdgeOfferings = false;
            state.targetProfileEdgeOfferings = undefined;
        },
        failedReceiveCreateEdgeOffering: state => {
            state.requestingCreateEdgeOffering = false;
        },
        failedReceiveEdgeOffering: state => {
            state.edgeOffering = undefined;
            state.requestingEdgeOffering = false;
        },
        failedReceiveEdgeOfferings: state => {
            state.edgeOfferings = undefined;
            state.requestingEdgeOfferings = false;
        },
        failedReceiveModifyEdgeOffering: state => {
            state.requestingModifyEdgeOffering = false;
        },
        failedReceiveRemoveEdgeOffering: state => {
            state.requestingRemoveEdgeOffering = false;
        },
        failedReceiveTargetProfileEdgeOfferings: state => {
            state.requestingTargetProfileEdgeOfferings = false;
            state.targetProfileEdgeOfferings = undefined;
        },
        receiveCreateEdgeOffering: {
            prepare: edgeOffering => {
                return {
                    payload: {
                        edgeOffering
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeOffering } = action.payload;
                state.edgeOfferings = state.edgeOfferings ? [...state.edgeOfferings, edgeOffering] : [edgeOffering];
                state.requestingCreateEdgeOffering = false;
            }
        },
        receiveEdgeOffering: {
            prepare: edgeOffering => {
                return {
                    payload: {
                        edgeOffering
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeOffering } = action.payload;
                state.edgeOffering = edgeOffering;
                state.requestingEdgeOffering = false;
            }
        },
        receiveEdgeOfferings: {
            prepare: edgeOfferings => {
                return {
                    payload: {
                        edgeOfferings
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeOfferings } = action.payload;
                state.edgeOfferings = edgeOfferings;
                state.requestingEdgeOfferings = false;
            }
        },
        receiveModifyEdgeOffering: {
            prepare: edgeOffering => {
                return {
                    payload: {
                        edgeOffering
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeOffering } = action.payload;
                state.edgeOfferings = state.edgeOfferings.map(offering => offering.id === edgeOffering.id ? edgeOffering : offering);
                state.requestingModifyEdgeOffering = false;
            }
        },
        receiveRemoveEdgeOffering: {
            prepare: edgeOfferingId => {
                return {
                    payload: {
                        edgeOfferingId
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeOfferingId } = action.payload;
                state.edgeOfferings = state.edgeOfferings.filter(offering => offering.id !== edgeOfferingId);
                state.requestingRemoveEdgeOffering = false;
            }
        },
        receiveTargetProfileEdgeOfferings: {
            prepare: edgeOfferings => {
                return {
                    payload: {
                        edgeOfferings
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeOfferings } = action.payload;
                state.requestingTargetProfileEdgeOfferings = false;
                state.targetProfileEdgeOfferings = edgeOfferings;
            }
        },
        requestCreateEdgeOffering: {
            prepare: (edgeOfferingPayload, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        edgeOfferingPayload
                    }
                };
            },
            reducer: state => {
                state.requestingCreateEdgeOffering = true;
            }
        },
        requestEdgeOffering: {
            prepare: (targetOrganization, edgeOfferingId, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        edgeOfferingId,
                        targetOrganization
                    }
                };
            },
            reducer: state => {
                state.requestingEdgeOffering = true;
            }
        },
        requestEdgeOfferings: {
            prepare: (targetOrganization, kexProfileId, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        kexProfileId,
                        targetOrganization
                    }
                };
            },
            reducer: state => {
                state.requestingEdgeOfferings = true;
            }
        },
        requestModifyEdgeOffering: {
            prepare: (edgeOfferingId, edgeOfferingPayload, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        edgeOfferingId,
                        edgeOfferingPayload
                    }
                };
            },
            reducer: state => {
                state.requestingModifyEdgeOffering = true;
            }
        },
        requestRemoveEdgeOffering: {
            prepare: (edgeOfferingId, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        edgeOfferingId
                    }
                };
            },
            reducer: state => {
                state.requestingRemoveEdgeOffering = true;
            }
        },
        requestTargetProfileEdgeOfferings: {
            prepare: (targetOrganization, kexProfileId, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        kexProfileId,
                        targetOrganization
                    }
                };
            },
            reducer: state => {
                state.requestingTargetProfileEdgeOfferings = true;
            }
        },
        resetEdgeOffering: state => {
            state.edgeOffering = undefined;
            state.requestingEdgeOffering = false;
        },
        resetEdgeOfferings: () => edgeOfferingsState,
        resetTargetProfileEdgeOfferings: state => {
            state.requestingTargetProfileEdgeOfferings = false;
            state.targetProfileEdgeOfferings = undefined;
        }
    }
});
export const { errorReceiveCreateEdgeOffering, errorReceiveEdgeOffering, errorReceiveEdgeOfferings, errorReceiveModifyEdgeOffering, errorReceiveRemoveEdgeOffering, errorReceiveTargetProfileEdgeOfferings, failedReceiveCreateEdgeOffering, failedReceiveEdgeOffering, failedReceiveEdgeOfferings, failedReceiveModifyEdgeOffering, failedReceiveRemoveEdgeOffering, failedReceiveTargetProfileEdgeOfferings, receiveCreateEdgeOffering, receiveEdgeOffering, receiveEdgeOfferings, receiveModifyEdgeOffering, receiveRemoveEdgeOffering, receiveTargetProfileEdgeOfferings, requestCreateEdgeOffering, requestEdgeOffering, requestEdgeOfferings, requestModifyEdgeOffering, requestRemoveEdgeOffering, requestTargetProfileEdgeOfferings, resetEdgeOffering, resetEdgeOfferings, resetTargetProfileEdgeOfferings } = edgeOfferingsSlice.actions;
export default edgeOfferingsSlice.reducer;
